(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["packtopya-unit-value"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('packtopya-unit-value')) {
    customElements.define('packtopya-unit-value', class extends HTMLElement {
      connectedCallback() {
        this._section = this.closest('.shopify-section, dialog');
        this._handleVariant = (event) => {
          if (!this.isConnected || !(event.target instanceof Element) || event.target.closest('product-card')) return;
          if (!event.promise || typeof event.promise.then !== 'function') return;

          event.promise.then(({ detail }) => {
            if (!this.isConnected || !detail?.html) return;
            if (detail.newProduct) {
              this.dataset.productId = String(detail.newProduct.id);
            } else if (detail.productId && String(detail.productId) !== this.dataset.productId) {
              return;
            }

            const sources = detail.html.querySelectorAll('packtopya-unit-value');
            const source = [...sources].find((element) => element.dataset.blockId === this.dataset.blockId);
            const currentContent = this.querySelector('[data-value-content]');
            const newContent = source?.querySelector('[data-value-content]');
            if (currentContent && newContent) currentContent.replaceWith(newContent.cloneNode(true));
            else if (currentContent) currentContent.replaceChildren();
          }).catch((error) => {
            if (error?.name !== 'AbortError') console.warn('[Packtopya] Birim fiyat güncellenemedi:', error);
          });
        };
        this._section?.addEventListener('shopify:product:select', this._handleVariant);
      }

      disconnectedCallback() {
        this._section?.removeEventListener('shopify:product:select', this._handleVariant);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
